import(/* webpackMode: "eager" */ "/vercel/path0/src/app/b2b/page.tsx");
